"use client";

import {
    Grid,
    Tab,
    TabList,
    TabGroup,
    TabPanel,
    TabPanels
} from "@tremor/react";
import { useSelector } from 'react-redux';
import { Skeleton } from "@mui/material";
import {
    CumulativePaymentExclusionByPaymentTypeKPI,
    CumulativePaymentExclusionByUserKPI,
    PaymentExclusionCountKPI,
    PaymentExclusionPerHourKPI,
    PaymentExclusionValueKPI,
} from "./helper";
import ComparativeCardKpi from "../component/comparativeCardKpi";
import KpiAreaChart from "../component/areaChart";
import ListProgressBarAccordion from "../component/listProgressBarAccordion";
import ListPaymentExclusion from "./list";
import { isLoading } from "../component/loading/store";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function PaymentExclusion() {
    const kpiPaymentExclusion = useSelector((state) => state.kpiPaymentExclusion)
    const loadingPaymentExclusion = useSelector((state) => isLoading(state, 'KPI_PAYMENT_EXCLUSION'))

    // faz o filtro das listas por marca selecionada pelo usuário
    const filteredKpiPaymentExclusion = useTrademarkFilter(kpiPaymentExclusion)

    const cardPaymentExclusionCountKPI = PaymentExclusionCountKPI(filteredKpiPaymentExclusion)
    const cardPaymentExclusionValueKPI = PaymentExclusionValueKPI(filteredKpiPaymentExclusion)

    const chartPaymentExclusionPerHourKPI = PaymentExclusionPerHourKPI(filteredKpiPaymentExclusion)

    const cardCumulativeByUserKPI = CumulativePaymentExclusionByUserKPI(filteredKpiPaymentExclusion)
    const cardCumulativeByPaymentTypeKPI = CumulativePaymentExclusionByPaymentTypeKPI(filteredKpiPaymentExclusion)

    return (
        <TabGroup className="mt-0">
            <TabList>
                <Tab>Visão geral</Tab>
                <Tab>Listagem</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <Grid numItemsSm={1} numItemsMd={2} numItemsLg={2} className="gap-6 mt-6">
                        {!loadingPaymentExclusion ? (
                            <>
                                <ComparativeCardKpi {...cardPaymentExclusionCountKPI} />
                                <ComparativeCardKpi {...cardPaymentExclusionValueKPI} />
                            </>
                        ) : (
                            <>
                                <Skeleton variant="rounded" height={150} />
                                <Skeleton variant="rounded" height={150} />
                            </>
                        )}
                    </Grid>

                    <div className="mt-6">
                        <Grid numItemsSm={1} numItemsMd={1} numItemsLg={1} className="gap-6 mt-6">
                            {!loadingPaymentExclusion ? (
                                <KpiAreaChart {...chartPaymentExclusionPerHourKPI} />
                            ) : (
                                <Skeleton variant="rounded" height={300} />
                            )}
                        </Grid>
                    </div>

                    <div className="mt-6">
                        <Grid numItemsSm={1} numItemsMd={1} numItemsLg={1} className="gap-6 mt-6">
                            {!loadingPaymentExclusion ? (
                                <>
                                    <ListProgressBarAccordion {...cardCumulativeByUserKPI} />
                                    <ListProgressBarAccordion {...cardCumulativeByPaymentTypeKPI} />
                                </>
                            ) : (
                                <>
                                    <Skeleton variant="rounded" height={300} />
                                    <Skeleton variant="rounded" height={300} />
                                </>
                            )}
                        </Grid>
                    </div>
                </TabPanel>
                <TabPanel>
                    <ListPaymentExclusion data={filteredKpiPaymentExclusion.listAllPaymentExclusion || []} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
}
